import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  FiltersEndpoints,
  ICreateFilterDTO,
  IFiltersResponse,
  IGetFiltersDTO,
  IFilterDetailsResponse,
  IDeleteFilterValueDTO,
  IGetFilterValuesDTO,
  IFilterValuesResponse,
  IEditFilterValueDTO,
  IGetFiltersListDTO,
  IFilterValue,
  ICreateFilterValueDTO,
  IImportSFiltersDTO,
  IMarketplaceAttributesResponse,
  IUpdateFilterMarketplaceMappingsDTO,
  IUpdateFilterMarketplaceMappingsResponse,
} from '@/models/filters.model';

class FiltersAPI {
  static getFilters(data?: IGetFiltersDTO): ApiResponse<IFiltersResponse> {
    return httpClient.get<IFiltersResponse>(FiltersEndpoints.FILTERS, { params: data });
  }

  static getFiltersList(data?: IGetFiltersListDTO): ApiResponse<IFiltersResponse> {
    return httpClient.get<IFiltersResponse>(`${FiltersEndpoints.FILTERS}/list`, { params: data });
  }

  static getFilterDetails(id: string): ApiResponse<IFilterDetailsResponse> {
    return httpClient.get<IFilterDetailsResponse>(`${FiltersEndpoints.FILTERS}/${id}`);
  }

  static createFilter(data: ICreateFilterDTO): ApiResponse<IFilterDetailsResponse> {
    return httpClient.post<IFilterDetailsResponse>(FiltersEndpoints.FILTERS, data);
  }

  static editFilter(id: string, data: Partial<ICreateFilterDTO>): ApiResponse<IFilterDetailsResponse> {
    return httpClient.patch<IFilterDetailsResponse>(`${FiltersEndpoints.FILTERS}/${id}`, data);
  }

  static deleteFilter(id: string): ApiResponse<IFilterDetailsResponse> {
    return httpClient.delete<IFilterDetailsResponse>(`${FiltersEndpoints.FILTERS}/${id}`);
  }

  static getFilterValues(data: IGetFilterValuesDTO): ApiResponse<IFilterValuesResponse> {
    return httpClient.get<IFilterValuesResponse>(`${FiltersEndpoints.FILTERS}/${data?.filter_id}/values`, {
      params: data,
    });
  }

  static deleteFilterValue(data: IDeleteFilterValueDTO): ApiResponse<void> {
    return httpClient.delete<void>(`${FiltersEndpoints.FILTERS}/${data.filter_id}/values/${data.id}`);
  }

  static editFilterValue(data: IEditFilterValueDTO): ApiResponse<IFilterValue> {
    return httpClient.patch<IFilterValue>(`${FiltersEndpoints.FILTERS}/${data.filter_id}/values/${data.id}`, data.data);
  }

  static createFilterValue(data: ICreateFilterValueDTO): ApiResponse<IFilterValue> {
    return httpClient.post<IFilterValue>(`${FiltersEndpoints.FILTERS}/${data.filter_id}/values`, data?.data);
  }

  static getFilterData(id: string): ApiResponse<IFilterDetailsResponse> {
    return httpClient.get<IFilterDetailsResponse>(`${FiltersEndpoints.FILTERS}/${id}`);
  }

  static importFilters(data: IImportSFiltersDTO): ApiResponse<void> {
    return httpClient.post<void>(FiltersEndpoints.FILTERS_IMPORT, convertModelToFormData(data));
  }

  static searchMarketplaceAttributes(params: {
    marketplace: string;
    q?: string;
    unmapped?: boolean;
    limit?: number;
  }): ApiResponse<IMarketplaceAttributesResponse> {
    return httpClient.get<IMarketplaceAttributesResponse>(FiltersEndpoints.MARKETPLACE_ATTRIBUTES, { params });
  }

  static updateMarketplaceMappings(
    filterId: string,
    data: IUpdateFilterMarketplaceMappingsDTO,
  ): ApiResponse<IUpdateFilterMarketplaceMappingsResponse> {
    return httpClient.put<IUpdateFilterMarketplaceMappingsResponse>(
      `${FiltersEndpoints.FILTERS}/${filterId}/marketplace-mappings`,
      data,
    );
  }
}

export default FiltersAPI;
